// Which sidebar link is "current" for a page. Pure so it can be tested (sidebarCurrent.test.js).
// Pages without a sidebar link of their own (add / edit / detail screens, nested routes) highlight the list
// they belong to.
const ALIASES = {
  newUser: '/accounts', editUser: '/accounts', 'change-password': '/accounts',
  ProductAdd: '/ProductList', ProductEdit: '/ProductList', product: '/ProductList',
  BrandAdd: '/BrandList', BrandEdit: '/BrandList', SliderAdd: '/SliderList', SliderEdit: '/SliderList',
  AddPage: '/Pages', EditPage: '/Pages', AddBlock: '/Blocks', EditBlock: '/Blocks',
  'faq-add': '/faq', 'faq-edit': '/faq', 'faq-addcategories': '/faq-categories', 'faq-editcategories': '/faq-categories',
  'faq-addsubcategories': '/faq-subcategories', 'faq-editsubcategories': '/faq-subcategories',
  'learn-add': '/learn', 'learn-edit': '/learn', 'learn-addcategories': '/learn-categories', 'learn-editcategories': '/learn-categories',
  'learn-addsubcategories': '/learn-subcategories', 'learn-editsubcategories': '/learn-subcategories',
  'plan-add': '/listing-plans', 'plan-edit': '/listing-plans', 'features-add': '/listing-features', 'features-edit': '/listing-features',
  'features-video-stream-add': '/listing-video-stream', 'features-video-stream-edit': '/listing-video-stream',
  'contact-view': '/contact-us',
};

const NESTED_ROUTES = [
  [/^\/(addCategory|editCategory)(\/|$)/, '/categories'],
  [/^\/[^/]+\/AddSubCategory$/, '/sub-categories'],
  [/^\/[^/]+\/[^/]+\/EditSubCategory$/, '/sub-categories'],
  [/^\/[^/]+\/SubFirst$/, '/sub-categories'],
  [/^\/AddCategoryField(\/|$)/, '/fields'],
  [/^\/TransactionHistory(\/|$)/, '/Transactions'],
  [/^\/ShippingDashboard(\/|$)/, '/Parcel2GoDashboard'],
  [/^\/WeeklyDeals(Add|Edit)(\/|$)/, '/WeeklyDeals'],
  [/^\/product\/view\//, '/ProductList'],
];

export const getCurrentMenuHref = (pathname, hrefs) => {
  const nested = NESTED_ROUTES.find(([pattern]) => pattern.test(pathname));
  const navigationPath = (nested && nested[1]) || ALIASES[pathname.split('/')[1]] || pathname;
  if (hrefs.includes(navigationPath)) return navigationPath;
  return hrefs
    .filter(href => navigationPath.startsWith(href + '/'))
    .sort((x, y) => y.length - x.length)[0] || null;
};
